export default __webpack_public_path__ + "static/media/gallery_05.8c3f1101.jpg";